<div class="modal is-active">
  <app-loader [Parent]="this"></app-loader>
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Please provide the following...</p>
    </header>
    <section class="modal-card-body"style="min-width: 800px;">
      <div>
        @for (field of Row.RequestedFields; track field) {
          <div>
            <app-field [Label]="getFieldDisplayName(field)">
              @if (getFieldType(field) == 'ParkingLot') {
                <div class="control select">
                  <select class="select input" (change)="mappingChanged($event)" id="{{field}}" [ngModel]="fieldMapping.get(field) || ''">
                    <option value="" disabled hidden>Select a value...</option>
                    @for (lot of parkingLots; track lot) {
                      <option value="{{lot.Id}}">{{lot.Name}}</option>
                    }
                  </select>
                </div>
              }
              @if (getFieldType(field) == 'RateSet') {
                <div class="control select">
                  <select class="select input" (change)="mappingChanged($event)" id="{{field}}">
                    <option selected disabled hidden>Select a value...</option>
                    @for (set of ratesets; track set) {
                      <option value="{{set.Id}}">{{set.Name}}</option>
                    }
                  </select>
                </div>
              }
              @if (getFieldType(field) == 'Text') {
                <div class="control">
                  <input class="input" (change)="mappingChanged($event)" id="{{field}}" [ngModel]="fieldMapping.get(field) || ''" type="text" placeholder="Enter a value..." />
                </div>
              }
              @if (getFieldType(field) == 'Date') {
                <div class="control">
                  <input class="input" (change)="mappingChanged($event)" id="{{field}}" [ngModel]="fieldMapping.get(field) || ''" type="datetime-local" placeholder="Select a value..." />
                </div>
              }
            </app-field>
            <br/>
          </div>
        }
      </div>

    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" (click)="cancel()">Cancel</button>
      <button class="button is-success" (click)="submit()">Submit</button>
    </footer>
  </div>
</div>